<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { MetaWhatsAppNumberPolicyPhone, WhatsAppPhoneStateColorMap } from '@/types';
import { phoneState } from '@/utils/whatsappMeta';

const props = defineProps<{ phone: MetaWhatsAppNumberPolicyPhone | null }>();
const { t } = useI18n();

const state = computed(() => phoneState(props.phone));

const badge = computed(() => WhatsAppPhoneStateColorMap[state.value]);
</script>

<template>
    <UiBadge :variant="badge.variant" :text-variant="badge.textVariant" size="sm">
        {{ t(`whatsappMeta.phoneState.${state}`) }}
    </UiBadge>
</template>
